import { Satisfaction } from 'lib-shared-legacy-types';

import { LanguageCustomizationForm } from './types';

interface CsatPreviewValues {
  rating_type: Satisfaction.RatingStyle;
  thank_you_message: string;
  followup_question: string;
  followup_question_placeholder_text: string;
  rating_question: string;
}

export function formatFormValuesFromCsatPreview(
  values: LanguageCustomizationForm.FormValues,
): CsatPreviewValues {
  return {
    followup_question: values.rating_follow_up_question,
    followup_question_placeholder_text: values.rating_placeholder_text,
    rating_question: values.rating_question,
    rating_type: values.look_and_feel,
    thank_you_message: values.rating_completed_message,
  };
}
